export const toCamelCase = (str) => {
  return str
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

export const categorizeDifficulty = (difficulty) => {
  const lowerCaseDifficulty = difficulty.toLowerCase();
  const categories = [];
  if (lowerCaseDifficulty.includes('beginner')) categories.push('Beginner');
  if (lowerCaseDifficulty.includes('intermediate')) categories.push('Intermediate');
  if (lowerCaseDifficulty.includes('advanced')) categories.push('Advanced');
  if (lowerCaseDifficulty.includes('social')) categories.push('Social');
  if (lowerCaseDifficulty.includes('all skill')) categories.push('All Skill Levels');
  if (categories.length === 0) categories.push('Other');
  return categories;
};
